import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showReturns, setShowReturns] = useState(false);
  const {
    language
  } = useLanguage();
  const t = translations[language].footer;
  return <footer className="py-6 bg-black border-t border-gray-800 text-center text-gray-400" data-id="element-56">
      <div className="max-w-5xl mx-auto px-4" data-id="element-57">
        {/* Copyright & Author Rights Disclaimer */}
        <div className="mb-6 pb-6 border-b border-gray-800" data-id="element-58">
          <h3 className="text-base font-semibold text-gray-300 mb-3" data-id="element-59">
            {t.copyright}
          </h3>
          <div className="text-xs text-gray-400 space-y-2 max-w-3xl mx-auto text-left md:text-center" data-id="element-60">
            <p data-id="element-61">{t.copyrightText1}</p>
            <p data-id="element-62">{t.copyrightText2}</p>
            <p data-id="element-63">{t.copyrightText3}</p>
          </div>
        </div>
        <div className="flex justify-center items-center gap-6 text-sm" data-id="element-64">
          <button onClick={() => setShowTerms(true)} className="hover:text-teal-300 transition-colors" data-id="element-65">
            {t.terms}
          </button>
          <button onClick={() => setShowReturns(true)} className="hover:text-teal-300 transition-colors" data-id="element-66">
            {t.returns}
          </button>
        </div>
        <p className="mt-4 text-xs" data-id="element-67">
          © {new Date().getFullYear()} {t.allRights}
        </p>
      </div>
      {/* Terms & Policies Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4 overflow-y-auto" data-id="element-68">
          <div className="bg-gradient-to-br from-teal-950 to-black border border-teal-800/50 rounded-xl p-6 md:p-8 max-w-2xl w-full max-h-[80vh] overflow-y-auto" data-id="element-69">
            <div className="flex justify-between items-center mb-4" data-id="element-70">
              <h2 className="text-xl md:text-2xl font-bold text-teal-300" data-id="element-71">
                {t.termsModal.title}
              </h2>
              <button onClick={() => setShowTerms(false)} className="text-gray-400 hover:text-white" data-id="element-72">
                <XIcon className="w-6 h-6" data-id="element-73" />
              </button>
            </div>
            <div className="space-y-4 text-gray-300 text-sm md:text-base" data-id="element-74">
              {t.termsModal.sections.map((section, index) => <div key={index} data-id="element-75">
                  <h3 className="font-bold text-teal-200" data-id="element-76">{section.title}</h3>
                  <p data-id="element-77">{section.content}</p>
                </div>)}
            </div>
          </div>
        </div>}
      {/* Returns Modal */}
      {showReturns && <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4 overflow-y-auto" data-id="element-78">
          <div className="bg-gradient-to-br from-teal-950 to-black border border-teal-800/50 rounded-xl p-6 md:p-8 max-w-2xl w-full max-h-[80vh] overflow-y-auto" data-id="element-79">
            <div className="flex justify-between items-center mb-4" data-id="element-80">
              <h2 className="text-xl md:text-2xl font-bold text-teal-300" data-id="element-81">
                {t.returnsModal.title}
              </h2>
              <button onClick={() => setShowReturns(false)} className="text-gray-400 hover:text-white" data-id="element-82">
                <XIcon className="w-6 h-6" data-id="element-83" />
              </button>
            </div>
            <div className="space-y-4 text-gray-300 text-sm md:text-base" data-id="element-84">
              {t.returnsModal.sections.map((section, index) => <div key={index} data-id="element-85">
                  <h3 className="font-bold text-teal-200" data-id="element-86">{section.title}</h3>
                  <p data-id="element-87">{section.content}</p>
                </div>)}
            </div>
          </div>
        </div>}
    </footer>;
}